import { fonts, colors, measurements, fontSizes} from "../../../app/theme";
import css from 'styled-jsx/css'

export const chart = css`
.chart {
  width: 100%;
  max-width: 21.875rem;
  background-color: ${colors.white};
  border: solid 1px ${colors.border};
  font-size: ${fontSizes.micro};
  border-radius: ${measurements.borderRadius};
  margin-bottom: 2rem;
}
.chart header {
  font: ${fonts.semiBold};
  font-size: ${fontSizes.body};
  padding: 1rem;
}

.series {
  background-color: ${colors.frame};
  color: ${colors.white};
  border-bottom-left-radius: ${measurements.borderRadius};
  border-bottom-right-radius: ${measurements.borderRadius};
}

.series ul {
  list-style: none;
  margin: 0;
  padding: 1rem 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.series ul li {
  display: flex;
  justify-content: center;
  align-items: center;
}

.series .text {
  padding-left: 0.2rem;
}

`
